import React from 'react'
import { ErrorMessagePage } from '../../../components/Error/ErrorMessagePage'
import MainContainerWithWindow from '../../../components/MainContainerWithWindow/MainContainerWithWindow'

export const ForbiddenError = () => {
  return (
    <MainContainerWithWindow>
      <ErrorMessagePage errorCode={'403'} errorText={'Нет доступа'} />
    </MainContainerWithWindow>
  )
}
